export const loanInformationSelector = ({ activeIds, entities }) => (
  entities.loanForgiveness.byId[activeIds.forgivenessId]?.loanInformation || {}
);
